import { J2Caution } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { IconButton, Tooltip } from '@mui/material'
import { differenceInDays } from '@e3dc-react/shell/Libs/date'
import React from 'react'

interface PromotionCodeWarningProp {
  expiringDate: Date
}

const MAX_DAYS_LEFT = 7

const getDaysLeftMessage = (validUntil: Date): number | null => {
  const currentDate = new Date()
  const expiryDate = new Date(validUntil)
  const daysLeft = differenceInDays(expiryDate, currentDate)

  if (daysLeft > 0 && daysLeft <= MAX_DAYS_LEFT) {
    return daysLeft
  }

  return null
}

/*
 * This component renders a warning tooltip if coupon is expiring in couple of days.
 */
const PromotionCodeWarning: React.FC<PromotionCodeWarningProp> = ({ expiringDate }) => {
  const { t } = useCustomTranslation()

  const daysLeftMessage = getDaysLeftMessage(expiringDate)

  if (daysLeftMessage === null) return null

  return (
    <Tooltip placement="top" title={t(`shop.promotion-code.days-left`, { daysLeftMessage })}>
      <IconButton>
        <J2Caution color="warning" />
      </IconButton>
    </Tooltip>
  )
}

export default PromotionCodeWarning
